__webpack_require__.p = "/Challenge-06-Interactive-comments-Frontend/";